/**
 * ComplianceDashboardPage - Compliance monitoring dashboard
 *
 * Surfaces the ComplianceDashboard from guardian components for admin/architect users.
 * Provides regulatory compliance status and audit trail monitoring.
 *
 * Route: /admin/compliance-dashboard
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconClipboardCheck } from '@tabler/icons-react';

import { ComplianceDashboard } from '@/guardian/ComplianceDashboard';
import { useAuth } from '@/auth/AuthContext';

export function ComplianceDashboardPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="orange">
            <IconClipboardCheck size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Compliance Dashboard</Title>
            <Text size="sm" c="dimmed">
              Regulatory compliance status and audit trail monitoring
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <ComplianceDashboard />
    </Container>
  );
}

export default ComplianceDashboardPage;
